/**
 * Store Ged Types
 */
export default {
    state: {
        types: [],
        ldm: 104,
    },

    mutations: {
        /**
         * Initialise le state users
         */
        setTypes: function (state, types) {
            state.types = types
        }
    },

    actions: {
        saveGedType: function (context, payload) {
            axios.request({
                url: '/api/ged-types' + (payload.gedType.id ? '/' + payload.gedType.id : ''),
                method: payload.gedType.id ? 'patch' : 'post',
                data: payload.gedType
            }).then(() => {
                payload.successFunction()
            }).catch(error => {
                payload.errorFunction(error)
            }).finally(() => {
                payload.finallyFunction()
                context.dispatch('init')
            })
        },
    },

    getters: {
        optionsGedTypes: state => state.types.map(type => ({label: type.nom, value: type.id}))
    }
}
